export const CFTC_SUMMARY_ONBOARDING_STORAGE_KEY = 'onboarding.cftcSummary.v1.seen';

export type CftcSummaryOnboardingState = {
  isOpen: boolean;
  step: number;
  hasSeen: boolean;
  dismissed: boolean;
};

export const createCftcSummaryOnboardingState = (hasSeen: boolean): CftcSummaryOnboardingState => ({
  isOpen: false,
  step: 0,
  hasSeen,
  dismissed: false,
});

export const readCftcSummaryOnboardingSeen = (storage?: Storage | null): boolean => {
  if (!storage) {
    return false;
  }
  try {
    return storage.getItem(CFTC_SUMMARY_ONBOARDING_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
};

export const writeCftcSummaryOnboardingSeen = (storage: Storage | null | undefined, seen = true) => {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(CFTC_SUMMARY_ONBOARDING_STORAGE_KEY, seen ? 'true' : 'false');
  } catch (error) {
    // Swallow storage errors to avoid breaking onboarding flow.
  }
};

export const shouldAutoOpenCftcSummaryOnboarding = (
  state: CftcSummaryOnboardingState,
  options: { isTrendView: boolean; positioningTourOpen: boolean; otherTourOpen: boolean },
) => {
  return (
    !options.isTrendView &&
    !options.positioningTourOpen &&
    !options.otherTourOpen &&
    !state.isOpen &&
    !state.dismissed &&
    !state.hasSeen
  );
};

export const getReplayCftcSummaryOnboardingState = (
  state: CftcSummaryOnboardingState,
): CftcSummaryOnboardingState => ({
  ...state,
  isOpen: true,
  step: 0,
  dismissed: false,
});

export const getCloseCftcSummaryOnboardingState = (
  state: CftcSummaryOnboardingState,
): CftcSummaryOnboardingState => ({
  ...state,
  isOpen: false,
  dismissed: true,
});

export const getSkipCftcSummaryOnboardingState = (
  state: CftcSummaryOnboardingState,
): CftcSummaryOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});

export const getDoneCftcSummaryOnboardingState = (
  state: CftcSummaryOnboardingState,
): CftcSummaryOnboardingState => ({
  ...state,
  isOpen: false,
  hasSeen: true,
  dismissed: false,
  step: 0,
});
